import isEqual from 'lodash.isequal';
import { conversationsService } from '@services';
import { conversationsConstants } from '@constants/conversations';
import { store } from 'store';

export const conversationsActions = {
    get,
    loadMore,
    update,
    getCounters,
    success,
    reset,
    getArchivedCounters,
};

function get(params, pageToken = null, pageSize = 15) {
    return dispatch => {
        if (!pageToken && !pageSize) {
            dispatch(request());
        }
        return conversationsService
            .get(params, pageToken, pageSize)
            .then(data => {
                const prevData = store.getState().conversations.data;
                if (isEqual(prevData, data)) {
                    return;
                }
                dispatch(success(data));
            })
            .catch(() => dispatch(error()));
    };
}

function loadMore(params, pageToken) {
    return dispatch => {
        return conversationsService
            .get(params, pageToken)
            .then(data => dispatch(successLoadMore(data)))
            .catch(() => dispatch(error()));
    };
}

function getCounters(params) {
    return dispatch => {
        return conversationsService
            .getCounters(params)
            .then(data => dispatch(successCounters(data)))
            .catch(() => dispatch(error()));
    };
}

function getArchivedCounters() {
    return dispatch => {
        return conversationsService
            .getArchivedCount()
            .then(data => dispatch(successArchived(data)))
            .catch(() => dispatch(error()));
    };
}

function request() {
    return { type: conversationsConstants.CONVERSATIONS_FETCH };
}

function success(payload) {
    return { type: conversationsConstants.CONVERSATIONS_SUCCESS, payload };
}

function successLoadMore(payload) {
    return { type: conversationsConstants.CONVERSATIONS_LOAD_MORE_SUCCESS, payload };
}

function successCounters(payload) {
    return { type: conversationsConstants.CONVERSATIONS_COUNTERS_SUCCESS, payload };
}

function successArchived(payload) {
    return { type: conversationsConstants.CONVERSATIONS_ARCHIVED_SUCCESS, payload };
}

function error() {
    return { type: conversationsConstants.CONVERSATIONS_ERROR };
}

function update(data) {
    return { type: conversationsConstants.CONVERSATIONS_UPDATE, data };
}

function reset() {
    return { type: conversationsConstants.CONVERSATIONS_RESET };
}
